<template>
  <line-chart
    v-if="chartData"
    :chart-data="chartData"
    :baseHexColor="baseHexColor"
    :height="300"
  ></line-chart>
</template>

<script>
import LineChart from "@/pages/Report/Components/LineChart.vue";
export default {
  components: { LineChart },
  props: ["presentPercentage", "baseHexColor"],
  methods: {
    generateChartData(presentPercentage) {
      return {
        labels: presentPercentage.labels,
        datasets: [
          {
            backgroundColor: "",
            borderColor: this.baseHexColor || "#000000",
            data: presentPercentage.data
          }
        ]
      };
    }
  },
  computed: {
    chartData() {
      if (!this.presentPercentage) return null;
      return this.generateChartData(this.presentPercentage);
    }
  }
};
</script>

<style lang="scss" scoped></style>
